<h2 mat-dialog-title>
	<mat-icon class="feedback-icon">feedback</mat-icon>
	Give Feedback
</h2>

<mat-dialog-content>
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<strong>{{ messageHeader }}</strong>

		<mat-selection-list formControlName="selectedId" [multiple]="false" [hideSingleSelectionIndicator]="true" cdkFocusInitial>
			@for (option of options; track option) {
				<mat-list-option [value]="option.id">{{ option.issue }}</mat-list-option>
			}
		</mat-selection-list>

		<strong>Let us know what we missed or where we can improve.</strong>

		<textarea formControlName="message" class="feedback-textarea"></textarea>
	</form>

</mat-dialog-content>

<mat-dialog-actions>
	<button mat-button mat-dialog-close>Cancel</button>
	<button mat-flat-button [disabled]="form.invalid" color="primary" (click)="onSubmit()">Submit</button>
</mat-dialog-actions>
